module.exports = __webpack_public_path__ + "img/completed-check-mark-aussie.29970bd3.svg";